import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425abeb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "streaks-index" }
const _hoisted_2 = {
  key: 0,
  class: "streaks-index__loading"
}
const _hoisted_3 = { key: 1 }

import { computed, ref } from 'vue';

import StreaksTable from '@/components/streaks/DCStreaksTable.vue';
import DCStreaksCreate from '@/components/streaks/partials/DCStreaksCreate.vue';

import DSPageHeader from '@/design-system/DSPageHeader.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';
import { FETCH_STREAKS } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreaksIndex',
  setup(__props) {

const store = useStore();
const request_pending = computed(() => {
  const { streak: streak_request_pending = {} } = store.state.requests_pending;
  return streak_request_pending.fetch_all;
});

store.dispatch(FETCH_STREAKS);

const streaks = computed(() => store.state.streak.streaks);
const createStreakModal = ref(DCStreaksCreate);

const handleCreateButtonClick = () => {
  createStreakModal.value.show_modal = true;
};

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DSPageHeader, { title: "Your Streaks" }, {
      right: _withCtx(() => [
        _createVNode(DSButton, {
          icon: "add",
          label: "Create New Streak",
          onClick: handleCreateButtonClick
        })
      ]),
      _: 1
    }),
    (request_pending.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_spinner_gears, {
            color: "primary",
            size: "3rem"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(StreaksTable, { streaks: streaks.value }, null, 8, ["streaks"])
        ])),
    _createVNode(DCStreaksCreate, {
      ref_key: "createStreakModal",
      ref: createStreakModal
    }, null, 512)
  ]))
}
}

})